import script from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"

import "./ProductFilter.vue?vue&type=style&index=0&id=7777404c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7777404c"]])

export default __exports__